'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTexture = function MdTexture(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.5 35l19.5-19.5v4.7l-14.8 14.8h-4.7z m19.5-3.4c0 1.8-1.6 3.4-3.4 3.4h-3.2l6.6-6.6v3.2z m-26.6-26.6h3.2l-6.6 6.6v-3.2c0-1.8 1.6-3.4 3.4-3.4z m11.4 0h4.7l-19.5 19.5v-4.7z m12.7 0.2c1.2 0.3 2.1 1.1 2.4 2.3l-27.4 27.3c-1.1-0.3-2-1.2-2.3-2.3z' })
        )
    );
};

exports.default = MdTexture;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/texture.js
// module id = 2047
// module chunks = 168707334958949